import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-334a00ee")

_pushScopeId("data-v-334a00ee")
const _hoisted_1 = { class: "edit-commands" }
const _hoisted_2 = { class: "command-tab" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "効果音", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "ふきだし", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "素材", -1)
const _hoisted_6 = { class: "tab-item" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa = _resolveComponent("fa")
  const _component_EditCommandSerif = _resolveComponent("EditCommandSerif")
  const _component_EditCommandOnomatope = _resolveComponent("EditCommandOnomatope")
  const _component_EditCommandBalloon = _resolveComponent("EditCommandBalloon")
  const _component_EditCommandUserImages = _resolveComponent("EditCommandUserImages")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("button", {
        class: ["tab-btn serif", { selected: _ctx.selectedTab == _ctx.serif }],
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTab = _ctx.serif))
      }, [
        _createVNode("span", null, [
          _createVNode(_component_fa, { icon: ['fas', 'home'] })
        ])
      ], 2),
      _createVNode("button", {
        class: ["tab-btn onomatope", { selected: _ctx.selectedTab == _ctx.onomatope }],
        disabled: _ctx.isFamous,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedTab = _ctx.onomatope))
      }, [
        _hoisted_3
      ], 10, ["disabled"]),
      _createVNode("button", {
        class: ["tab-btn balloon", { selected: _ctx.selectedTab == _ctx.balloon }],
        disabled: _ctx.isFamous,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedTab = _ctx.balloon))
      }, [
        _hoisted_4
      ], 10, ["disabled"]),
      _createVNode("button", {
        class: ["tab-btn user-image", { selected: _ctx.selectedTab == _ctx.userImage }],
        disabled: _ctx.isFamous,
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedTab = _ctx.userImage))
      }, [
        _hoisted_5
      ], 10, ["disabled"])
    ]),
    _createVNode("div", _hoisted_6, [
      (_ctx.selectedTab == _ctx.serif)
        ? (_openBlock(), _createBlock(_component_EditCommandSerif, {
            key: 0,
            editStore: _ctx.editStore
          }, null, 8, ["editStore"]))
        : _createCommentVNode("", true),
      (_ctx.selectedTab == _ctx.onomatope)
        ? (_openBlock(), _createBlock(_component_EditCommandOnomatope, {
            key: 1,
            editStore: _ctx.editStore
          }, null, 8, ["editStore"]))
        : _createCommentVNode("", true),
      (_ctx.selectedTab == _ctx.balloon)
        ? (_openBlock(), _createBlock(_component_EditCommandBalloon, {
            key: 2,
            editStore: _ctx.editStore
          }, null, 8, ["editStore"]))
        : _createCommentVNode("", true),
      (_ctx.selectedTab == _ctx.userImage)
        ? (_openBlock(), _createBlock(_component_EditCommandUserImages, {
            key: 3,
            editStore: _ctx.editStore
          }, null, 8, ["editStore"]))
        : _createCommentVNode("", true)
    ])
  ]))
})